"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getErrorMessage: function() {
        return getErrorMessage;
    },
    getErrorStatusCode: function() {
        return getErrorStatusCode;
    }
});
const _httpstatuscodes = require("http-status-codes");
const _validation = require("../utils/validation");
const _validationerror = require("./validation.error");
const _homeeerror = require("./homee.error");
function getErrorStatusCode(err) {
    const anyError = err;
    var _anyError_statusCode;
    const maybeStatusCode = (_anyError_statusCode = anyError == null ? void 0 : anyError.statusCode) != null ? _anyError_statusCode : anyError == null ? void 0 : anyError.status;
    if ((0, _validation.isNumber)(maybeStatusCode)) {
        return maybeStatusCode;
    }
    if (err instanceof _validationerror.ValidationError) {
        return _httpstatuscodes.StatusCodes.BAD_REQUEST;
    }
    return _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR;
}
function getErrorMessage(err, options = {}) {
    const { useDefaultMessageForErrorInstances, defaultErrorMessage = 'Unknown error' } = options;
    let message = undefined;
    if (err instanceof _homeeerror.HomeeError || err instanceof Error && !useDefaultMessageForErrorInstances) {
        message = err.message;
    }
    message = message || defaultErrorMessage;
    return message;
}

//# sourceMappingURL=utils.js.map